const DEFAULT_BACKEND_PORT = '8000';

function getApiBase() {
  const override = process.env.REACT_APP_API_BASE;
  if (override) {
    return override.replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    const isLocalhost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.startsWith('192.168.') ||
      hostname.endsWith('.local');

    if (isLocalhost) {
      return `${protocol}//${hostname}:${DEFAULT_BACKEND_PORT}/api`;
    }

    if (hostname === 'herclesglobal.com' || hostname === 'www.herclesglobal.com') {
      return 'https://api.herclesglobal.com/api';
    }

    return `${protocol}//${hostname}/api`;
  }

  return `http://localhost:${DEFAULT_BACKEND_PORT}/api`;
}

export const API_BASE = getApiBase();
